var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-container" },
    [
      !_vm.$store.getters.isAllCountry
        ? [
            _c("div", { staticClass: "page-title" }, [
              _vm._v(" " + _vm._s(_vm.$t("menu.account_settings")) + " "),
            ]),
            _c("MerchantInfoItem"),
            _c("div", { staticClass: "line-bottom-1px" }),
          ]
        : _vm._e(),
      _c("div", { staticClass: "sectionItem" }, [
        _c("div", { staticClass: "sectionItem_title" }, [
          _vm._v(_vm._s(_vm.$t("system.password"))),
        ]),
        _c("div", { staticClass: "sectionItem_name" }, [
          _c(
            "span",
            { staticClass: "tip" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "info", icon: "el-icon-key" },
                  on: { click: _vm.onClickLoginChange },
                },
                [_vm._v(_vm._s(_vm.$t("system.change_your_password")))]
              ),
            ],
            1
          ),
        ]),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }